import {Observable} from 'rxjs/Observable';
import {createChallengeCompleted, errorCreatingChallengeAction, Types} from "./actions";

import * as ResourceActions from 'resources/actions';
import * as ResourceApi from 'api/resources';
import {isNoU} from "../../utils/DBUtils";

const submitCreateChallengeEpic = ($action) => $action.ofType(Types.SUBMIT_CREATE_CHALLENGE)
    .mergeMap((action) => ResourceApi.create(ResourceApi.Types.Challenge, {
            permalink: action.permalink,
            sponsoredType: action.sponsoredType,
            lang: action.lang,
        }, [])
        // Side effect, to remove if better routing solution is implemented
        //     .do((response) => history.pushState({}, `/break/${response.response.object.id}/edit`))
            .mergeMap((response) => Observable.of(
                createChallengeCompleted(response.response.object.id),
                ResourceActions.createdResourceAction(response.response.object, null, [], [], [])
            ))
        .catch(err => Observable.of(
            !isNoU(err.xhr) ? errorCreatingChallengeAction(err.response)
            : {type: "ERROR", error: err}))
    );

export default [
    submitCreateChallengeEpic
]



// WEBPACK FOOTER //
// ./public/pages/BreakCreator/epics.js